var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "data--privacy_1_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5596e6",
    d: "M16,31.36C9.185,31.36,3.64,25.815,3.64,19V6c0-0.199,0.161-0.36,0.36-0.36c4.354,0,8.635-1.784,11.746-4.895 c0.141-0.141,0.368-0.141,0.509,0C19.365,3.856,23.646,5.64,28,5.64c0.199,0,0.36,0.161,0.36,0.36v13 C28.36,25.815,22.815,31.36,16,31.36z M4.36,6.356V19c0,6.418,5.222,11.64,11.64,11.64S27.64,25.418,27.64,19V6.356 C23.339,6.263,19.134,4.511,16,1.504C12.866,4.511,8.661,6.263,4.36,6.356z M21.36,22h-0.72v-1.5c0-2.088-1.379-3.864-3.433-4.419 c-0.146-0.04-0.25-0.165-0.265-0.314c-0.014-0.15,0.066-0.292,0.201-0.358c0.909-0.439,1.496-1.385,1.496-2.409 c0-1.456-1.184-2.64-2.64-2.64s-2.64,1.185-2.64,2.64c0,1.023,0.587,1.969,1.497,2.409c0.135,0.065,0.216,0.208,0.202,0.358 c-0.014,0.149-0.12,0.274-0.265,0.314c-2.054,0.555-3.434,2.332-3.434,4.419V22h-0.72v-1.5c0-2.163,1.275-4.036,3.243-4.866 C13.111,14.999,12.64,14.03,12.64,13c0-1.853,1.507-3.36,3.36-3.36s3.36,1.507,3.36,3.36c0,1.03-0.471,1.999-1.243,2.634 c1.968,0.83,3.243,2.703,3.243,4.866V22z"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle",
    style: {
      fill: "none"
    },
    width: 32,
    height: 32
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "../static/product-explorer-main-offerings/assets/security.8815b10f4b8345948f985a0d7fe33ece.svg";
export { ForwardRef as ReactComponent };